import { RecurlyAccount } from '../../types/types'
import CurrentPaymentInfoComponent from './CurrentPaymentInfoComponent'
import { EditPaymentDetailsComponent } from '../Payment/EditPaymentDetailsComponent'
import { useState } from 'react'

interface propTypes {
  account: RecurlyAccount
  setAccount: Function
}

export const PaymentDetailsComponent = (props: propTypes) => {
  const { account, setAccount } = props
  const [showPaymentForm, setShowPaymentForm] = useState(false)

  const togglePaymentForm = () => {
    setShowPaymentForm(!showPaymentForm)
  }

  return (
    <div className="plus-card mb-40">
      <div className="plus-card-description p-15">Payment Method</div>
      <div className="d-lg-flex justify-content align-items-center py-15">
        {account && (
          <>
            {showPaymentForm ? (
              <div className="col">
                <EditPaymentDetailsComponent
                  billingInfo={account.billingInfo}
                  setAccount={setAccount}
                  togglePaymentForm={togglePaymentForm}
                  account={account}
                />
              </div>
            ) : (
              <div className="col-lg-7 mb-20 mb-lg-0">
                <CurrentPaymentInfoComponent account={account} />
              </div>
            )}
            {showPaymentForm ? (
              ''
            ) : (
              <div className="col-lg-5 d-flex justify-content-center justify-content-xl-left">
                <button
                  className="btn btn-primary"
                  onClick={() => togglePaymentForm()}
                >
                  Update Payment Info
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentDetailsComponent
